import { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router';

import { ANY_SPORT_MARKET_SHOP_INSTANT_BUY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { glossary } from '@sorare/core/src/lib/glossary';
import { PrimaryBuyFlow } from '@sorare/marketplace/src/components/primaryBuy/PrimaryBuyBuyField/PrimaryOfferBuyFieldWrapper/PrimaryBuyFlow/index.tsx';

const BuyCardPage = () => {
  const { offerId } = useParams();
  const navigate = useNavigate();
  const { generateSportContextPath } = useSportContext();
  const { isMobileApp, postMessage } = useIsMobileApp();
  const paymentSucceededRef = useRef(false);
  const [paymentSucceeded, setPaymentSucceeded] = useState(false);

  const exit = () => {
    if (isMobileApp) {
      postMessage('closeCurrentWebview');
    } else {
      navigate(generateSportContextPath(ANY_SPORT_MARKET_SHOP_INSTANT_BUY), {
        replace: true,
      });
    }
  };

  const recordPaymentSuccess = () => {
    paymentSucceededRef.current = true;
    setPaymentSucceeded(true);
  };

  const exitUnlessPaymentSucceeded = () => {
    if (!paymentSucceededRef.current) {
      exit();
    }
  };

  if (!offerId || paymentSucceeded) {
    return null;
  }

  return (
    <PrimaryBuyFlow
      offerId={offerId}
      onSuccess={recordPaymentSuccess}
      onClose={exitUnlessPaymentSucceeded}
      onBuyConfirmationClose={exit}
      primaryBuyConfirmationOptions={{
        actions: {
          primary: {
            label: <FormattedMessage {...glossary.gotIt} />,
            onClick: exit,
          },
        },
        hideSecondaryOrTickets: true,
      }}
    />
  );
};

export default BuyCardPage;
